/** Major event / metro hubs — shown first in location dropdowns. */
export const POPULAR_INDIAN_LOCATIONS: readonly string[] = [
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Hyderabad",
  "Chennai",
  "Kolkata",
  "Pune",
  "Ahmedabad",
  "Jaipur",
  "Goa",
  "Chandigarh",
  "Lucknow",
  "Kochi",
  "Indore",
  "Nagpur",
  "Noida",
  "Gurugram",
];

/** All states and union territories of India (alphabetical within the main list). */
export const INDIAN_STATES_AND_UTS: readonly string[] = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

const POPULAR_SET = new Set(POPULAR_INDIAN_LOCATIONS);
const STATES_SET = new Set(INDIAN_STATES_AND_UTS);

export const INDIAN_STATES_SORTED: readonly string[] = INDIAN_STATES_AND_UTS.filter(
  (name) => !POPULAR_SET.has(name),
)
  .slice()
  .sort((a, b) => a.localeCompare(b));

export function isKnownIndianLocation(value: string): boolean {
  return POPULAR_SET.has(value) || STATES_SET.has(value);
}

export function isIndianStateName(value: string): boolean {
  return STATES_SET.has(value.trim());
}
